export const setListingRows = listingRows => ({
  type: 'SET_LISTINGS_ROWS',
  payload: listingRows,
});

export const setFocusGroups = setFocusGropDict => ({
  type: 'SET_FOCUS_GROUP',
  payload: setFocusGropDict,
});

export const setDeleteGroupModalOpen = openStatus => ({
  type: 'SET_DELETE_GROUP_MODAL_OPEN',
  payload: openStatus,
});

export const setDeletedGroupName = deletedGroupName => ({
  type: 'SET_DELETE_GROUP_NAME',
  payload: deletedGroupName,
});

export const setBadGroups = badGroups => ({
  type: 'SET_BAD_GROUPS',
  payload: badGroups,
});
